import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, pluck } from 'rxjs/operators';
import { LayoutConfig } from './layout-config';

@Injectable()
export class LayoutStoreService {
  public readonly config$: Observable<LayoutConfig>;

  private readonly initialLayoutConfig: LayoutConfig = {
    sidebarExpanded: true,
    title: 'Title Page'
  };
  private configSource: BehaviorSubject<LayoutConfig>;

  public readonly notificationConfig$: Observable<LayoutConfig>;
  private readonly alertInitialLayoutConfig: LayoutConfig = {
    notificationSidebarExpanded: false
  };
  private notificationConfigSource: BehaviorSubject<LayoutConfig>;
  public notificationSidebarWidthSource = new BehaviorSubject<number>(0);
  notificationSidebarWidth$ = this.notificationSidebarWidthSource.asObservable();

  constructor() {
    this.configSource = new BehaviorSubject(this.initialLayoutConfig);
    this.config$ = this.configSource.asObservable();

    this.notificationConfigSource = new BehaviorSubject(this.alertInitialLayoutConfig);
    this.notificationConfig$ = this.notificationConfigSource.asObservable();

  }

  get notificationSidebarExpanded(): Observable<boolean> {
    return this.notificationConfig$.pipe(
      pluck('notificationSidebarExpanded'),
      distinctUntilChanged()
    ) as Observable<boolean>;
  }

  get sidebarExpanded(): Observable<boolean> {
    return this.config$.pipe(
      pluck('sidebarExpanded'),
      distinctUntilChanged()
    ) as Observable<boolean>;
  }

  public setSidebarExpanded(value: boolean): void {
    this.configSource.next(
      Object.assign(this.configSource.value, { sidebarExpanded: value })
    );
  }

  public setNotificationSidebarExpanded(value: boolean): void {
    this.notificationConfigSource.next(
      Object.assign(this.notificationConfigSource.value, { notificationSidebarExpanded: value })
    );
  }

  setNotificationSidebarWidth(width: number): void {
    this.notificationSidebarWidthSource.next(width);
  }

  /**
   * Get Title
   */
  public get getTitle(): Observable<string> {
    return this.config$.pipe(
      pluck('title'),
      distinctUntilChanged()
    ) as Observable<string>;
  }

  /**
   * Set Title
   * @param value Title on string
   */
  public setTitle(value: string): void {
    this.configSource.next(Object.assign(this.configSource.value, { title: value }));
    document.title = 'MAER | POS - ' + value;
  }
}
